import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/iDays_logo.png'
import _imports_1 from '@/assets/img/text_rotation_image.png'
import _imports_2 from '@/assets/img/hand_rock.png'
import _imports_3 from '@/assets/img/music_lady.png'


const _hoisted_1 = { class: "onboarding landing" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-start justify-content-between\"><img src=\"" + _imports_0 + "\" class=\"idaysLogo\"><div class=\"position-relative\"><img src=\"" + _imports_1 + "\" class=\"rotateImg\"><img src=\"" + _imports_2 + "\" class=\"handRock\"></div></div>", 1)
const _hoisted_3 = { class: "pt-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "musicLadyImage"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_localized_text, {
      type: "h1",
      localizedKey: "app_Vinci<br />i biglietti IDays 2024!",
      text: "Vinci<br />i biglietti IDays 2024!"
    }),
    _createVNode(_component_localized_text, {
      type: "p",
      localizedKey: "app_dall’8 giugno al 4 luglio 2024",
      text: "dall’8 giugno al 4 luglio 2024",
      class: "ff_unbounded"
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "btn btn-primary mt-5",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/welcome')))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_Let's rock!",
          text: "Let's rock!"
        })
      ]),
      _createVNode(_component_localized_text, {
        localizedKey: "app_Scopri il regolamento",
        text: "Scopri il regolamento",
        class: "linkButton mt-5 d-block",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openRulesModal()))
      })
    ]),
    _hoisted_4
  ]))
}